<template>
  <div class="tinymce-editor">
    <Editor
      :id="id"
      v-model="myValue"
      :init="init"
      :disabled="disabled"
      @onClick="onClick"
      @onPaste="onPaste"
      placeholder="请输入问卷欢迎语"
      @blur.stop="handleBlur"
    >
    </Editor>
  </div>
</template>

<script>
import tinymce from "tinymce/tinymce";
import Editor from "@tinymce/tinymce-vue";
import "tinymce/plugins/indent2em"; // 首行缩进
// import "tinymce/themes/silver/theme";
// import "tinymce/plugins/image";
// import "tinymce/plugins/contextmenu";
// import "tinymce/plugins/wordcount";
// import "tinymce/plugins/colorpicker";
// import "tinymce/plugins/textcolor";
// import "tinymce/plugins/fullscreen";
// import "tinymce/icons/default";
export default {
  components: {
    Editor,
  },
  props: {
    id: {
      type: String,
      required: false,
    },
    value: {
      type: String,
      required: false,
    },
    triggerChange: {
      type: Boolean,
      default: false,
      required: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    plugins: {
      type: [String, Array],
      default:
        "lists image link media table textcolor wordcount contextmenu fullscreen indent2em",
    },
    toolbar: {
      type: [String, Array],
      default:
        "undo redo | styleselect | fontselect forecolor fontsizeselect bold italic underline | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent indent2em",
      branding: false,
    },
  },
  data() {
    return {
      // 初始化配置
      init: {
        selector: "#myeditor",
        paste_data_images: true,
        language_url: "/mytinymce/langs/zh_CN.js",
        language: "zh_CN",
        skin_url: "/mytinymce/skins/lightgray",
        height: 300,
        plugins: this.plugins,
        content_style: "div {font-famliy: font-famliy: impact,chicago;}",
        font_formats:
          "微软雅黑='微软雅黑';宋体='宋体';黑体='黑体';仿宋='仿宋';楷体='楷体';隶书='隶书';幼圆='幼圆';Andale Mono=andale mono,times;Arial=arial,helvetica,sans-serif;Arial Black=arial black,avant garde;Book Antiqua=book antiqua,palatino;Comic Sans MS=comic sans ms,sans-serif;Courier New=courier new,courier;Georgia=georgia,palatino;Helvetica=helvetica;Impact=impact,chicago;Symbol=symbol;Tahoma=tahoma,arial,helvetica,sans-serif;Terminal=terminal,monaco;Times New Roman=times new roman,times;Trebuchet MS=trebuchet ms,geneva;Verdana=verdana,geneva;Webdings=webdings;Wingdings=wingdings",
        fontsize_formats:
          "8px 10px 12px 14px 16px 18px 20px 22px 24px 26px 28px 30px 32px 34px 36px 48px",
        toolbar: this.toolbar,
        branding: false,
        menubar: false,
        toolbar_drawer: false,
        // images_upload_handler: (blobInfo, success) => {
        //   let formData = new FormData();
        //   formData.append("file", blobInfo.blob(), blobInfo.filename());
        //   formData.append("biz", "jeditor");
        //   formData.append("jeditor", "1");
        //   uploadAction(window._CONFIG['domianURL'] + '/sys/common/upload', formData).then(res => {
        //   if (res.success) {
        //     if (res.message == 'local') {
        //       const img = 'data:image/jpeg;base64,' + blobInfo.base64()
        //       success(img)
        //     } else {
        //       let img = getFileAccessHttpUrl(res.message)
        //       success(img)
        //     }
        //   }
        // })
        // },
        setup: (editor) => {
          let _this = this;
          editor.on("blur", function (e) {
            _this.handleBlur();
          });
          editor.on("focus", function (e) {
            _this.handleBlur();
          });
        },
      },
      myValue: this.value,
      reloading: false,
      url: {
        uploadFiles: "/assistsystem/tbTaskResult/uploadFiles", // 上传文件
      },
    };
  },
  computed: {
    uploadURL: function () {
      return `${window._CONFIG["domianURL"]}/${this.url.uploadFiles}?type=AI`;
    },
  },
  mounted() {
    this.initATabsChangeAutoReload();
  },
  activated() {
    this.initATabsChangeAutoReload();
  },
  methods: {
    handleBlur() {
      this.$emit("input", this.myValue);
      this.$emit("change", this.myValue);
      setTimeout(() => {
        this.$emit("blur", this.myValue);
      }, 0);
    },
    onPaste(event) {
      let _this = this;
      // 实现图片粘贴上传
      const items = (event.clipboardData || window.clipboardData).items;
      // items为伪数组  微信/QQ截图以及此富文本区域内复制粘贴的length为1,鼠标右键复制粘贴图片以及文本的复制粘贴的length为2;
      let len = items.length;
      for (let i = 0; i < len; i++) {
        if (items[i].kind == "file" && items[i].type.indexOf("image") != -1) {
          // 判断是否为图片类型
          event.preventDefault(); // 如果是图片阻止自动粘贴到富文本编辑器
        } else {
          // 不是图片类型直接粘贴, 跳过oss上传处理
          console.log("粘贴的不是图片");
        }
      }
    },
    reload() {
      this.reloading = true;
      this.$nextTick(() => (this.reloading = false));
    },

    onClick(e) {
      this.$emit("onClick", e, tinymce);
    },
    // 可以添加一些自己的自定义事件，如清空内容
    clear() {
      this.myValue = "";
    },

    /**
     * 自动判断父级是否是 <a-tabs/> 组件，然后添加事件监听，自动触发reload()
     *
     * 由于 tabs 组件切换会导致 tinymce 无法输入，
     * 只有重新加载才能使用（无论是vue版的还是jQuery版tinymce都有这个通病）
     */
    initATabsChangeAutoReload() {
      // 获取父级
      let tabs = this.getVmParentByName(this, "ATabs");
      let tabPane = this.getVmParentByName(this, "ATabPane");
      if (tabs && tabPane) {
        // 用户自定义的 key
        let currentKey = tabPane.$vnode.key;
        // 添加事件监听
        tabs.$on("change", (key) => {
          // 切换到自己时执行reload
          if (currentKey === key) {
            this.reload();
          }
        });
      } else {
        // update--begin--autor:wangshuai-----date:20200724------for：富文本编辑器切换tab无法修改------
        // let tabLayout = this.getVmParentByName(this, 'TabLayout')
        // tabLayout.excuteCallback(() => {
        //   this.reload();
        // });
        // update--begin--autor:wangshuai-----date:20200724------for：文本编辑器切换tab无法修改------
      }
    },
    getVmParentByName(vm, name) {
      let parent = vm.$parent;
      if (parent && parent.$options) {
        if (parent.$options.name === name) {
          return parent;
        } else {
          let res = this.getVmParentByName(parent, name);
          if (res) {
            return res;
          }
        }
      }
      return null;
    },
  },
  watch: {
    value(newValue) {
      this.myValue = newValue == null ? "" : newValue;
    },
    myValue(newValue) {
      if (this.triggerChange) {
        this.$emit("change", newValue);
      } else {
        this.$emit("input", newValue);
      }
    },
  },
};
</script>
<style scoped></style>
